<template>
  <layout>
    <div class="frontpage-content">
      <div class="mobile-banner d-lg-none">
        <div style="text-align: left; display: inline-block; max-width: 500px; padding: 10px;">
          <br />
          <h1>{{ 'frontpage.banner.title' | i18n }}</h1>
          <br />
          <p style="font-size: 1.5em;" v-html="$options.filters.i18n('frontpage.banner.text')"></p>
        </div>
      </div>

      <div class="banner d-none d-lg-block">
        <div class="banner-front">

        </div>
        <div class="content-wrapper banner-text">
          <br />
          <br />
          <br />
          <br />
          <h1>{{ 'frontpage.banner.title' | i18n }}</h1>
          <br />
          <p style="max-width: 400px; font-size: 1.5em;" v-html="$options.filters.i18n('frontpage.banner.text')"></p>
        </div>
      </div>

      <div class="content-wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md" style="text-align: center;">
              <div class="start-link" @click="openCalculation(false)">
                <div class="operation-scope-selection house-operation-selection translucent-border">
                  <div class="operation-scope-header">
                    Talon<br />
                    korjaus
                  </div>
                  <div class="start-button">
                    ALOITA <i class="fas fa-arrow-alt-circle-right"></i>
                  </div>
                </div>

                <div class="tag-cloud">
                  <span v-for="tag in houseTags" :style="{ 'font-size': tag[1] + 'em' }">{{ tag[0] }} </span>
                </div>
              </div>
            </div>
            <div class="col-md" style="text-align: center;">
              <br class="d-md-none" />
              <div class="start-link" @click="openCalculation(true)">
                <div class="operation-scope-selection room-operation-selection translucent-border">
                  <div class="operation-scope-header">
                    Huonetilan<br />
                    korjaus
                  </div>
                  <div class="start-button">
                    ALOITA <i class="fas fa-arrow-alt-circle-right"></i>
                  </div>
                </div>

                <div class="tag-cloud">
                  <span v-for="tag in roomTags" :style="{ 'font-size': tag[1] + 'em' }">{{ tag[0] }} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>


<script>
  import Layout from './Layout'
  import calculationService from '../api/calculationService'

  export default {
    mounted() {
      setTimeout(() => {
        $(this.$el).find('.banner').addClass('centered');
      }, 1000);
    },

    methods: {
      openCalculation(isRoomCalculation) {
        calculationService.getUUID().then(uuid => {
          this.$router.push((isRoomCalculation ? '/tila/' : '/talo/') + uuid);
        });
      }
    },

    components: {
      Layout
    },

    data() {
      return {
        houseTags: [
          ['julkisivu', 1.0],
          ['lautaverhous', 1.0],
          ['kustannusarvio', 1.2],
          ['alapohja', 0.8],
          ['maankaivuu', 1.0],
          ['uusiminen', 1.0],
          ['bitumisively', 1.0],
          ['suunnittelija', 1.0],
          ['lisälämmöneristäminen', 1.0],
          ['tasoitus', 1.0],
          ['kerrokset', 0.8],
          ['perusmuuri', 1.0],
          ['purku', 1.0],
          ['salaojat', 1.0],
          ['puhdistaminen', 1.0],
          ['ammattilainen', 1.0],
          ['vesikatto', 1.2],
          ['ikkunat', 1.0],
          ['tulisijat', 1.0],
          ['maanpinta', 1.0],
          ['valesokkeli', 1.0],
          ['muotoilu', 0.8],
          ['ulko-ovet', 1.0],
          ['rossipohja', 1.0],
          ['suunnitelma', 0.8],
          ['ilmanvaihto', 1.0],
          ['jätelava', 1.0],
          ['vesikate', 1.2],
          ['kaksoisbetonialapohja', 1.0],
          ['maanvarainen', 1.0],
          ['julkisivuverhous', 0.8]
        ],
        roomTags: [
          ['sauna', 1.0],
          ['märkätila', 0.8],
          ['korjaus', 1.0],
          ['pintamateriaali', 1.2],
          ['pesuhuone', 0.8],
          ['paneli', 1.0],
          ['ammattilainen', 0.8],
          ['asbesti', 1.0],
          ['laatoitus', 1.0],
          ['jätelava', 1.0],
          ['vesieristys', 1.0],
          ['suunnitelma', 1.0],
          ['koepala', 1.0],
          ['keittiö', 0.8],
          ['remontti', 1.2],
          ['levytys', 1.0],
          ['kustannusarvio', 1.0],
          ['tutkimus', 1.0],
          ['lattialämmitys', 1.2],
          ['suunnittelija', 1.0],
          ['betonilaatta', 1.0],
          ['läpivienti', 1.0],
          ['sertifikaatti', 1.0],
          ['tasoitus', 1.0],
          ['purku', 1.0],
          ['silikoni', 1.0],
          ['vesikaluste', 0.8],
          ['suihku', 1.2],
          ['allas', 1.0],
          ['laasti', 0.8],
          ['maalaus', 1.0]
        ]
      }
    }
  }
</script>


<style scoped>
  .frontpage-content {
    background-image: url("../assets/layout/brownTexture.jpg");
    padding-bottom: 80px;
  }

  .mobile-banner {
    background-image: url("../assets/layout/korjausarvio_ylakuva_tausta.jpg");
    background-size: auto 100%;
    height: 580px;
    background-position: center top;
    text-align: center;
    margin-bottom: 50px;
  }

  .banner {
    position: relative;
    background-image: url("../assets/layout/korjausarvio_ylakuva_tausta.jpg");
    height: 800px;
    margin-bottom: 50px;
    transition: height 3s, background-position 3s ease-in-out;
    background-size: auto 100%;
    background-position: right 25% center;
  }

  .banner-text {
    opacity: 0;
    transition: opacity 1s ease 3s;
  }

  .banner.centered {
    height: 580px;
    background-size: auto 100%;
    background-position: center center;
  }

  .banner.centered .banner-text, .banner.centered .banner-front {
    opacity: 1.0;
  }

  .banner-front {
    opacity: 0;
    transition: opacity 1s ease 3s;
    position: absolute;
    right: 0;
    top: 0;
    height: 580px;
    width: 535px;
    background-image: url("../assets/layout/korjausarvio_ylakuva_tyokalut.png");
  }


  .house-operation-selection {
    background-image: url("../assets/layout/korjausarvio_talon_korjaus.png");
  }

  .room-operation-selection {
    background-image: url("../assets/layout/korjausarvio_huonetilan_korjaus.png");
  }

  .operation-scope-selection {
    /*margin: 10px;*/
    padding: 10px;
    text-align: center;
    position: relative;
    display: inline-block;
    width: 100%;
    max-width: 560px;
    height: 330px;

    background-repeat: no-repeat;
    background-position: right bottom;
    /*background-size: 100%;*/
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 25px;
  }


  .operation-scope-selection img {
    max-width: 100%;
  }
  .operation-scope-header {
    padding: 0.5em;
    font-size: 2em;
    font-weight: bold;
    display: inline-block;
    float: left;
    text-align: left;
  }

  .start-button {
    background-color: #c31a2f;
    color: white;
    padding: 0.7em;
    position: absolute;
    left: 2em;
    bottom: 3em;
    text-align: center;
    width: 40%;
    font-size: 1.2em;
  }

  .tag-cloud {
    margin-top: 30px;
    font-size: 1.2em;
    text-align: center;
  }

  .start-link {
    cursor: pointer;
  }

  .start-link:hover {
    opacity: 0.8;
  }
</style>



// WEBPACK FOOTER //
// src/components/Frontpage.vue